import { deleteItemFromCollection } from "directus/src/operations";

export async function deleteTimesheetEntry({ id }) {
  try {
    const query = {
      fields: ["id"],
    };
    const data = await deleteItemFromCollection("timesheet", id, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
